import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormButton from "../../../../Components/Buttons/FormButton";
import InputFiled from "../../../../Components/FormTag/InputFiled";
import CustomizableTableForAddAndEdit from "../../../../Components/Tables/CustomizableTableForAddAndEdit";
import { DataFromAPI3 } from "../../../../Data/testData";
import PageHeader from "../../../../Layout/PageHeader";
import { DATE_REGEX, NUMBER_REGEX } from "../../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../../Shared/Helper/ValidationMessage";
import { createAsn } from "../../model/AsnOverview.type";
import { FormValues } from "./ReturnsItem.type";
import CustomDropdown from "../../../../Components/Dropdown/CustomDropdown";
import { ItemCodeDropDownData } from "../../../../Data/Inbound";
import CommonModal from "../../../../Components/Modals/CommonModal";
import ViewOrderDetailsModalLayout from "../../../../Layout/ViewOrderDetailsModalLayout";

export default function OverviewAdd() {
  interface DataRow {
    [key: string]: any; // Allow any key-value pairs
  }

  const [tableData, setTableData] = useState<DataRow[]>([]);
  const [show, setShow] = useState(false);

  const handleSelect = (
    selectedItem: any,
    rowIndex: number,
    columnKey: string
  ) => {
    const matchedRow = DataFromAPI3.find(
      (data) => data.itemCode === selectedItem.item
    );

    if (matchedRow) {
      const updatedData = [...tableData];
      // Update the existing row with matched data and set the selected value for the specified column
      updatedData[rowIndex] = {
        ...matchedRow,
        [columnKey]: selectedItem.itemCode,
      };
      setTableData(updatedData);
    } else {
      // Optional: You can add logic here if no match is found
      console.warn("No matching row found in DataFromAPI3");
    }
  };
  const handleShow = () => setShow(!show);

  const columns = [
    { key: "line", label: "Line#", disable: true, customStyles: {} },
    {
      key: "itemCode",
      customStyles: { width: "25%" },
      customStyleForBody: { width: "25%" },
      label: "Item Code",
      disable: true,
      inputType: (
        <CustomDropdown
          data={ItemCodeDropDownData}
          handleSelect={(item) => handleSelect(item, 0, "itemCode")}
        />
      ),
    },
    { key: "itemDescription", label: "Item Description", disable: true },
    { key: "uom", label: "UOM", disable: true },
    { key: "expectedQty", label: "Expected Qty",  disable: true, inputType: (<input className="form-control form-control-md w-25"/>)},
  ];

  const pageName = "Returns";
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const [createAsnData, setCreateAsnData] = useState<createAsn>(
    new createAsn()
  );
  const [asnAddItemList, setASNAddItemList] = useState<FormValues[]>([]);
  const navigation = useNavigate();
  //   useEffect(() => {
  //     setCollapseStates((prev) => prev.map(() => true));
  //   }, []);
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<createAsn>({
    defaultValues: createAsnData,
  });
  const nextData: SubmitHandler<createAsn> = (data) => {
    setCreateAsnData(data);
    navigation("/inbound/returns/overview");
  };
  const handleCancelBtn = () => {
    navigation("/inbound/asn/overview");
    // reset(new createAsn());
    // setASNAddItemList([])
  };
  const handelAddLineItem = (data: FormValues) => {
    setASNAddItemList((asn) => [...asn, data]);
  };
  const handelRemoveLineData = (itemCode: string) => {
    const updatedDataList = asnAddItemList.map((group) => ({
      items: group.items.filter((item) => item.itemCode !== itemCode),
    }));
    setASNAddItemList(updatedDataList);
  };
  return (
    <>

      <PageHeader
        addUrl="/inbound/returns/overview/add"
        listUrl="/inbound/returns/overview"
        viewType={true}
      />

      <h5 className="text-start mt-1 mb-3">Returns</h5>
      <div className="my-2 bg-white rounded py-1 pb-4 px-2">
        <form>
          <div className="d-flex mt-3 px-2 gap-3">
            <div className="col-5 px-2">
              <label className="fw-medium">Order/Shipment/Tracking #</label>
              <div className="mt-1">
                <InputFiled
                  type="text"
                  tabIndex={1}
                  register={register}
                  name="tracking"
                  errors={errors.tracking}
                  pattern={{
                    type: NUMBER_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                  className="form-control"
                  placeholder="Enter Tracking"
                />
                <p
                  className="text-primary text-decoration-none mb-0 cursor-pointer fs-12"
                  onClick={handleShow}
                >
                  View order detail
                </p>
              </div>
            </div>
            <div className="col-5 px-2">
              <label className="fw-medium">Return Date</label>
              <div className="mt-1">
                <InputFiled
                  type="date"
                  tabIndex={2}
                  register={register}
                  name="expectedDate"
                  errors={errors.expectedDate}
                  pattern={{
                    type: DATE_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                  className="form-control"
                  placeholder="Enter Expected Date"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="my-2 bg-white rounded py-3 px-3 test h-100">
        <CustomizableTableForAddAndEdit
          columns={columns}
          initialData={[]}
          dataFromAPI={DataFromAPI3}
          filterColumn="itemCode"
          tableDataFilteredFromCustomDropdown={tableData}
        />
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={3}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={4}
            className="sph-btn sph-shift me-4"
            handleClick={handleCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>

      <CommonModal
        handleClose={handleShow}
        show={show}
        heading="Shipments"
        content={<ViewOrderDetailsModalLayout />} 
        modalSize="modal-lg"
        // customClassName="view-shipment-modal"
        footerButtonsActive={false}
        customClassNameForBody="view-order-modal-body"
      />
    </>
  );
}
